export default ()=>{
    window.onorientationchange=()=>{
        location.reload();
    }
    localStorage.has_rotate=window.orientation==0? 0 : 1;
}



// WEBPACK FOOTER //
// ./src/util/rotate.js